// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSavings_root__3SEVS"};